import type { ResolveMap } from '@ms-cloudpack/common-types';
import { findResolveMapEntry } from '@ms-cloudpack/package-utilities';

/**
 * Generate bundler aliases for deduped packages from the resolve map.
 * Maps package names to their resolved paths to ensure all imports use the same version.
 */
export function getDedupeAliases(options: { resolveMap: ResolveMap; dedupe?: string[] }): Record<string, string> {
  const { resolveMap, dedupe } = options;
  const aliases: Record<string, string> = {};

  if (!dedupe || dedupe.length === 0) {
    return aliases;
  }

  for (const packageName of dedupe) {
    const packageEntry = findResolveMapEntry({ packageName, resolveMap });

    if (!packageEntry) {
      throw new Error(`Package "${packageName}" is in dedupe list but not found in resolve map`);
    }

    aliases[packageName] = packageEntry.path;
  }

  return aliases;
}
